var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_13705)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_461_13705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 0H0V40H39.9999V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_461_13705)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_461_13705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_461_13705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2605 4.48094C32.0752 4.48094 31.1055 5.4507 31.1055 6.63602C31.1055 7.82125 32.0752 8.79102 33.2605 8.79102C34.4457 8.79102 35.4155 7.82125 35.4155 6.63602C35.4155 5.4507 34.4457 4.48094 33.2605 4.48094Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5645 11.7318V13.6631",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9561 11.7318V13.6631",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9782 0.587139C11.793 0.587139 10.8232 1.5569 10.8232 2.74214C10.8232 3.92745 11.793 4.89722 12.9782 4.89722C14.1636 4.89722 15.1332 3.92745 15.1332 2.74214C15.1332 1.5569 14.1636 0.587139 12.9782 0.587139Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6982 4.89773H11.258C10.1687 4.89773 9.27734 5.78898 9.27734 6.87844V9.28219C9.27734 9.55133 9.49555 9.76953 9.76469 9.76953H16.1916C16.4607 9.76953 16.6789 9.55133 16.6789 9.28219V6.87844C16.6789 5.78898 15.7876 4.89773 14.6982 4.89773Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2822 7.8382V9.76953",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 7.8382V9.76953",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8835 26.5901C18.6983 26.5901 17.7285 27.5598 17.7285 28.7451C17.7285 29.9304 18.6983 30.9001 19.8835 30.9001C21.0688 30.9001 22.0385 29.9304 22.0385 28.7451C22.0385 27.5598 21.0688 26.5901 19.8835 26.5901Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6035 30.8997H18.1633C17.0739 30.8997 16.1826 31.7909 16.1826 32.8804V35.2841C16.1826 35.5533 16.4008 35.7715 16.67 35.7715H23.0968C23.366 35.7715 23.5842 35.5533 23.5842 35.2841V32.8804C23.5842 31.7909 22.6929 30.8997 21.6035 30.8997Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 33.8402V35.7715",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5791 33.8402V35.7715",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0471 13.6628C29.778 13.6628 29.5598 13.4446 29.5598 13.1754V10.7716C29.5598 10.179 29.8239 9.64551 30.2397 9.28176C27.3831 7.05152 23.7889 5.72215 19.8838 5.72215V11.2385C26.0517 11.2385 31.0682 16.1677 31.2093 22.3018H36.7256C36.6766 19.1327 35.7522 16.1762 34.1841 13.6628H30.0471Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5018 6.06363C16.615 6.31246 16.6787 6.58816 16.6787 6.87816V9.28191C16.6787 9.55113 16.4605 9.76934 16.1914 9.76934H9.76449C9.55637 9.76934 9.37926 9.63863 9.30934 9.45504C8.62168 10.0103 7.97809 10.618 7.38574 11.273L11.4782 14.9717C13.5512 12.6794 16.5487 11.2389 19.8829 11.2389V5.72262C18.7246 5.72262 17.5942 5.8409 16.5018 6.06363Z",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2505 39.3574C29.9143 38.6615 36.7286 31.4106 36.7286 22.5677C36.7286 22.4789 36.7276 22.3904 36.7262 22.302H31.2089C31.211 22.3903 31.2123 22.4788 31.2123 22.5677C31.2123 27.5284 28.0235 31.7439 23.5841 33.2777V35.2846C23.5841 35.5538 23.3659 35.772 23.0968 35.772H16.67C16.4007 35.772 16.1826 35.5538 16.1826 35.2846V33.2777C11.7432 31.744 8.55434 27.5284 8.55434 22.5677C8.55434 19.645 9.66137 16.9809 11.4786 14.9715L7.38754 11.274C4.68512 14.2616 3.03809 18.2218 3.03809 22.5677C3.03809 31.4106 9.8523 38.6615 18.5161 39.3574",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7607 9.90691C36.4382 9.24785 35.7601 8.79129 34.9804 8.79129H31.5403C30.4509 8.79129 29.5596 9.68254 29.5596 10.7719V13.1757C29.5596 13.4449 29.7778 13.6631 30.0469 13.6631H36.4738C36.7429 13.6631 36.9611 13.4449 36.9611 13.1757V12.6413",
    stroke: "#1A1B21",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_13705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9999,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollment);
export default __webpack_public_path__ + "static/media/enrollment.7a0065dd673efd07cb4ea1da78ff88c5.svg";
export { ForwardRef as ReactComponent };